import { useEffect, useState } from "react";
import { useCommonComponentContext, getAllDataCodename } from "@maysoft/common-component-react";

import Helpers from "../../../commons/helpers";
import CategoryService from "../../../services/message/Category.service";

import { CodeNameCommon } from "../../../constants/enums";
import { ICodename, ITopic } from "../../../commons/interfaces";

export type ITopicError = { [k in keyof ITopic]?: string };

const useSelectData = ({ organizationId }: { organizationId?: string }) => {
    const { language, userInfo, tenantCode, serviceCode } = useCommonComponentContext();

    const [categoryData, setCategoryData] = useState<ICodename[]>([]);
    const [typeData, setTypeData] = useState<ICodename[]>([]);

    useEffect(() => {
        getCategoryData();
        getTypeData();
    }, []);

    const getCategoryData = async () => {
        const result = await CategoryService.getAll({
            serviceCode: serviceCode,
            tenantCode: tenantCode,
        });
        setCategoryData(result.map((item) => ({ code: item.id, name: Helpers.getDefaultValueMultiLanguage(item.name, language) })));
    };

    const getTypeData = async () => {
        const result = await getAllDataCodename({
            serviceCode: serviceCode,
            group: [CodeNameCommon.TopicType],
            organizationId: organizationId || userInfo?.userProfile?.organizationId,
        });

        const newList = (result.get(CodeNameCommon.TopicType) || []).map((item) => ({ code: Number(item.code), name: item.name }));

        setTypeData(newList);
    };

    return { categoryData, typeData };
};

export default useSelectData;
